module.exports = __webpack_public_path__ + "fonts/LatoLatin-Bold.3ff66ad.woff2";